// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_contentFormBlock__UCaOI {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: var(--FORM_MAX_WIDTH);
  background: var(--COLOR_FOREGROUND);
  border-radius: var(--RADIUS_12);
}

.styles_headerBlock__gJF3z {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: var(--PADDING_4);
}

.styles_iconAndTextBlock__EUBA1 {
  display: flex;
  align-items: center;
}

.styles_iconBlock__cpjWU {
  display: flex;
  align-items: center;
  margin-right: var(--MARGIN_16);
}

.styles_filterBlock__OUd11 {
  display: flex;
  margin-top: var(--MARGIN_24);
  flex-direction: column;
}

.styles_titleStyle__F6HGg {
  color: var(--COLOR_PRIMARY_950);
  font-family: var(--FONT_SEMIBOLD);
  font-size: var(--FONT_SIZE_SUB_TITLE);
  font-style: normal;
  font-weight: var(--WEIGHT_600);
  line-height: var(--LINE_HEIGHT_20);
}

.styles_closeStyle__FLmNS {
  display: flex;
  cursor: pointer;
  border: 0;
  background-color: transparent;
}

.styles_mainBlock__l6cNh {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.styles_checkboxGroupStyle__UCq8i .ant-checkbox-wrapper {
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.styles_labelStyle__NdQCT {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  /* margin-top: var(--MARGIN_4); */
  height: var(--SIZE_20);
  text-transform: uppercase;
  margin-left: var(--MARGIN_4);
}

.styles_allTagsOptionLabelBlock__LEKSS {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: var(--MARGIN_6);
  height: var(--SIZE_20);
}

.styles_allTagsOptionLabel__uEIdC {
  color: var(--COLOR_PRIMARY_950);
  font-family: var(--FONT_MEDIUM);
  font-size: var(--FONT_SIZE_TEXT);
  font-style: normal;
  font-weight: var(--WEIGHT_NORMAL);
  line-height: var(--LINE_HEIGHT_20);
  margin-left: var(--MARGIN_4);
}

.styles_allTagsOptionBlock__VdRZX {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.styles_allTagsOptionBlock__VdRZX .ant-radio-wrapper {
  width: 45%;
  margin-bottom: var(--MARGIN_10);
}

.styles_allTagsOptionBlock__VdRZX .ant-radio-wrapper:last-child {
  margin-bottom: 0px;
}

.styles_tagLabelStyle__RVuJq {
  color: var(--COLOR_PRIMARY_950);
  font-family: var(--FONT_MEDIUM);
  font-size: var(--FONT_SIZE_TEXT);
  font-style: normal;
  font-weight: var(--WEIGHT_NORMAL);
  line-height: var(--LINE_HEIGHT_20);
  margin-bottom: var(--MARGIN_6);
}

.styles_footerBlock__-T38Q {
  width: 100%;
  display: flex;
  flex-direction: row;
  padding-top: var(--PADDING_24);
}

.styles_buttonCancelStyle__J2TMz {
  width: 100%;
  padding-right: var(--PADDING_12);
}

.styles_buttonCreateStyle__Ejh33 {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/organisms/forms/CreatorFilterForm/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,4BAA4B;EAC5B,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,iCAAiC;EACjC,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,iCAAiC;EACjC,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,iCAAiC;EACjC,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb","sourcesContent":[".contentFormBlock {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  width: var(--FORM_MAX_WIDTH);\n  background: var(--COLOR_FOREGROUND);\n  border-radius: var(--RADIUS_12);\n}\n\n.headerBlock {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding-top: var(--PADDING_4);\n}\n\n.iconAndTextBlock {\n  display: flex;\n  align-items: center;\n}\n\n.iconBlock {\n  display: flex;\n  align-items: center;\n  margin-right: var(--MARGIN_16);\n}\n\n.filterBlock {\n  display: flex;\n  margin-top: var(--MARGIN_24);\n  flex-direction: column;\n}\n\n.titleStyle {\n  color: var(--COLOR_PRIMARY_950);\n  font-family: var(--FONT_SEMIBOLD);\n  font-size: var(--FONT_SIZE_SUB_TITLE);\n  font-style: normal;\n  font-weight: var(--WEIGHT_600);\n  line-height: var(--LINE_HEIGHT_20);\n}\n\n.closeStyle {\n  display: flex;\n  cursor: pointer;\n  border: 0;\n  background-color: transparent;\n}\n\n.mainBlock {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.checkboxGroupStyle :global(.ant-checkbox-wrapper) {\n  height: 25px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.labelStyle {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  /* margin-top: var(--MARGIN_4); */\n  height: var(--SIZE_20);\n  text-transform: uppercase;\n  margin-left: var(--MARGIN_4);\n}\n\n.allTagsOptionLabelBlock {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: var(--MARGIN_6);\n  height: var(--SIZE_20);\n}\n\n.allTagsOptionLabel {\n  color: var(--COLOR_PRIMARY_950);\n  font-family: var(--FONT_MEDIUM);\n  font-size: var(--FONT_SIZE_TEXT);\n  font-style: normal;\n  font-weight: var(--WEIGHT_NORMAL);\n  line-height: var(--LINE_HEIGHT_20);\n  margin-left: var(--MARGIN_4);\n}\n\n.allTagsOptionBlock {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n}\n\n.allTagsOptionBlock :global(.ant-radio-wrapper) {\n  width: 45%;\n  margin-bottom: var(--MARGIN_10);\n}\n\n.allTagsOptionBlock :global(.ant-radio-wrapper:last-child) {\n  margin-bottom: 0px;\n}\n\n.tagLabelStyle {\n  color: var(--COLOR_PRIMARY_950);\n  font-family: var(--FONT_MEDIUM);\n  font-size: var(--FONT_SIZE_TEXT);\n  font-style: normal;\n  font-weight: var(--WEIGHT_NORMAL);\n  line-height: var(--LINE_HEIGHT_20);\n  margin-bottom: var(--MARGIN_6);\n}\n\n.footerBlock {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  padding-top: var(--PADDING_24);\n}\n\n.buttonCancelStyle {\n  width: 100%;\n  padding-right: var(--PADDING_12);\n}\n\n.buttonCreateStyle {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentFormBlock": `styles_contentFormBlock__UCaOI`,
	"headerBlock": `styles_headerBlock__gJF3z`,
	"iconAndTextBlock": `styles_iconAndTextBlock__EUBA1`,
	"iconBlock": `styles_iconBlock__cpjWU`,
	"filterBlock": `styles_filterBlock__OUd11`,
	"titleStyle": `styles_titleStyle__F6HGg`,
	"closeStyle": `styles_closeStyle__FLmNS`,
	"mainBlock": `styles_mainBlock__l6cNh`,
	"checkboxGroupStyle": `styles_checkboxGroupStyle__UCq8i`,
	"labelStyle": `styles_labelStyle__NdQCT`,
	"allTagsOptionLabelBlock": `styles_allTagsOptionLabelBlock__LEKSS`,
	"allTagsOptionLabel": `styles_allTagsOptionLabel__uEIdC`,
	"allTagsOptionBlock": `styles_allTagsOptionBlock__VdRZX`,
	"tagLabelStyle": `styles_tagLabelStyle__RVuJq`,
	"footerBlock": `styles_footerBlock__-T38Q`,
	"buttonCancelStyle": `styles_buttonCancelStyle__J2TMz`,
	"buttonCreateStyle": `styles_buttonCreateStyle__Ejh33`
};
export default ___CSS_LOADER_EXPORT___;
